import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import Banner from "../components/Banner";
import WorkshopSection from "../components/WorkshopSection";
import "../css/global.css";
import "../css/WorkshopsPage.css";

/* ── Image sets per workshop ── */
const MACHINERY = [
  "/wp-content/uploads/2016/02/machinery-shop.jpg",
  "/wp-content/uploads/2016/02/machinery-shop2.jpg",
  "/wp-content/uploads/2016/02/machinery-shop3.jpg",
  "/wp-content/uploads/2016/02/machinery-shop4.jpg",
  "/wp-content/uploads/2016/02/machinery-shop5.jpg",
];

const HULL = [
  "/wp-content/uploads/2016/02/hull-repair.jpg",
  "/wp-content/uploads/2016/02/hull-repair2.jpg",
  "/wp-content/uploads/2016/02/hull-repair3.jpg",
  "/wp-content/uploads/2016/02/hull-repair4.jpg",
  "/wp-content/uploads/2016/02/hull-repair5.jpg",
];

const PROPELLER = [
  "/wp-content/uploads/2016/02/P1010224.jpg",
  "/wp-content/uploads/2016/02/P1181068.jpg",
];

const PIPE = [
  "/wp-content/uploads/2016/02/pipe-repairs.jpg",
  "/wp-content/uploads/2016/02/pipe-repairs2.jpg",
  "/wp-content/uploads/2016/02/pipe-repairs3.jpg",
  "/wp-content/uploads/2016/02/pipe-repairs4.jpg",
  "/wp-content/uploads/2016/02/pipe-repairs5.jpg",
];

const DIVING = [
  "/wp-content/uploads/2016/02/DSC_9480.jpg",
  "/wp-content/uploads/2016/02/d4.jpg",
  "/wp-content/uploads/2016/02/d3.jpg",
];

const ANCILLARY = [
  "/wp-content/uploads/2016/02/DSC_0161.jpg",
  "/wp-content/uploads/2016/02/DSC_0176.jpg",
  "/wp-content/uploads/2016/02/DSC_4971.jpg",
  "/wp-content/uploads/2016/02/DSC_4980.jpg",
];

const AUTOMATION = [
  "/wp-content/uploads/2016/02/MVC-527F.jpg",
  "/wp-content/uploads/2016/02/MVC-528F.jpg",
  "/wp-content/uploads/2016/02/MVC-529F.jpg",
];

const ELECTRONIC = [
  "/wp-content/uploads/2016/02/P1010222.jpg",
  "/wp-content/uploads/2016/02/P1010223.jpg",
  "/wp-content/uploads/2016/02/P1010224-1.jpg",
];

/* ── Main Page Component ── */
const WorkshopsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="workshops-page">
      <Header />

      <Banner backgroundImage="/wp-content/uploads/2016/05/DSC0080.jpg" />

      <section className="contentwrapper clearfix">
        <div className="content clearfix">
          {/* Breadcrumbs */}
          <div className="breadcrumbs">
            <Link to="/" className="home">
              Home
            </Link>{" "}
            &gt; <span>Workshops</span>
          </div>

          <h1>Workshops</h1>

          <div id="work-shop">
            {/* Intro text */}
            <div className="workshops-intro">
              <p>
                The shipyard owns the biggest collection of heavy steel
                processing and welding machinery in Sri Lanka. Shipyard piers
                and all workshops have ancillary services such as oxygen;
                acetylene, compressed air etc. and powerful illumination system
                to ensure to carryout fabrication work day and night.
              </p>
              <p>
                The workshops are capable of handling a full complement of tasks
                and the listing below are but a few of our services,
              </p>
              <ul>
                <li>
                  The yard is fully geared and equipped for carrying out heavy
                  fabrication work in steel and aluminium and has a capacity to
                  process 7000+ tons of steel per year
                </li>
                <li>
                  Production area is equipped with latest machinery and
                  technology including lifting facility (overhead cranes &amp;
                  swing Arm cranes). An area of 9,400 m<sup>2</sup> is allocated
                  for ship repairs, while 10,680 m<sup>2</sup> area is allocated
                  for shipbuilding operations
                </li>
                <li>
                  Shipyard boasts of weather protected production area 7,000 m
                  <sup>2</sup> with moving facility (traveling shed) to use
                  shore cranes for production, mainly for shipbuilding
                </li>
                <li>
                  Performance standard for protective coatings (PSPC) workshop
                  of 580 m<sup>2</sup> – Climate and dust control in house
                  blasting and painting facility mainly for shipbuilding units
                </li>
                <li>
                  Workshop area allocated for support services 2,660 m
                  <sup>2</sup>, while dedicated cryogenic workshops are also
                  available
                </li>
              </ul>
            </div>

            {/* Action links */}
            <div className="workshops-action-links">
              <Link to="/shipyard-layout">
                Click here to view dockyard layout
              </Link>
              <span style={{ margin: "0 12px", color: "#999" }}></span>
              <Link to="/shipyard-360">
                Click here to view shipyard 360 visuals
              </Link>
            </div>

            {/* Workshop grid – 4 rows of 2 columns */}
            <div className="workshops-grid">
              {/* Row 1: Machinery + Hull */}
              <div className="workshop-row">
                <WorkshopSection
                  title="Machinery repairs"
                  items={[
                    "Overhauling of main engines, auxiliary engines",
                    "Alignment of bearings",
                    "Turbo charger repairs etc",
                  ]}
                  images={MACHINERY}
                />
                <WorkshopSection
                  title="Hull repairs"
                  items={[
                    "Submerged arc welding, MIG, TIG, MAG welding",
                    "Profile cutting machines",
                    "Plate rollers",
                    "Hydraulic presses",
                  ]}
                  images={HULL}
                  reverse
                />
              </div>

              {/* Row 2: Propeller + Pipe */}
              <div className="workshop-row">
                <WorkshopSection
                  title="Propeller repairs"
                  items={[
                    "All repairs to damaged and broken propellers",
                    "Faring dented blades",
                    "Profile matching",
                    "Renewal of damaged sections",
                    "Static balancing etc",
                  ]}
                  images={PROPELLER}
                />
                <WorkshopSection
                  title="Pipe repairs"
                  items={[
                    "Any type of pipe renewal work",
                    "Equipped with the latest hydraulic pipe benders and cutters",
                    "Grit blasting and coating of pipes",
                    "Hot dip galvanizing of pipes",
                  ]}
                  images={PIPE}
                  reverse
                />
              </div>

              {/* Row 3: Diving + Ancillary */}
              <div className="workshop-row">
                <WorkshopSection
                  title="Diving services"
                  items={[
                    "Underwater hull cleaning and repairing",
                    "Stern gland repacking",
                    "Inspection of bottom damage",
                  ]}
                  images={DIVING}
                />
                <WorkshopSection
                  title="Ancillary services"
                  items={[
                    "Accommodation repairs",
                    "Lifeboat repairs",
                    "Life raft repairs",
                    "Servicing and calibration of fire fighting systems",
                    "Inspection and certification of fire fighting systems",
                    "Wire splicing and canvas work",
                  ]}
                  images={ANCILLARY}
                  reverse
                />
              </div>

              {/* Row 4: Automation + Electronic */}
              <div className="workshop-row">
                <WorkshopSection
                  title="Automation repairs"
                  items={[
                    "Servicing and installation of main and auxiliary engine motoring and safety control systems",
                    "Servicing, calibration and installation of temperature monitoring systems",
                    "Boiler controls, fire detection systems",
                    "Inserting of gas",
                    "Electronic and pneumatic tank gauging",
                    "Oil discharge monitoring",
                    "Gas detection",
                    "Auto unloading systems etc",
                  ]}
                  images={AUTOMATION}
                />
                <WorkshopSection
                  title="Electronic repairs"
                  items={[
                    "Servicing and installation of all types of communication equipment",
                    "Servicing and repairs of navigation aids, radar and gyro",
                    "Servicing and repairs of echo sounders, direction finders, speed logs etc",
                  ]}
                  images={ELECTRONIC}
                  reverse
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </div>
  );
};

export default WorkshopsPage;
